import { PaymentMethodsResponse } from 'adyen-web-new';

import { IAdyenAvailablePaymentMethods, EFundingSource } from '@model';

export const mapAdyenConfigurationFromDomain = (config: IAdyenAvailablePaymentMethods): PaymentMethodsResponse => ({
  paymentMethods: config.paymentMethods.map((method) => ({
    ...method,
    type: method.type ?? '',
    name: method.name ?? '',
    configuration: method.configuration ?? undefined,
    brand: method.brand ?? undefined,
    brands: method.brands ?? undefined,
    fundingSource: method.fundingSource === EFundingSource.Debit ? 'debit' : undefined,
    group: {
      type: method.group?.type ?? '',
      name: method.group?.name ?? '',
      paymentMethodData: method.group?.paymentMethodData ?? '',
    },
  })),
  storedPaymentMethods: config.storedPaymentMethods.map((method) => ({
    type: method.type ?? '',
    name: method.name ?? '',
    supportedShopperInteractions: method.supportedShopperInteractions ?? [],
    storedPaymentMethodId: method.id ?? undefined,
    brand: method.brand ?? undefined,
    id: method.id ?? '',
    expiryMonth: method.expiryMonth ?? undefined,
    expiryYear: method.expiryYear ?? undefined,
  })),
});
